import { useRouter } from "next/router";
import Link from "next/link";
import { useState } from "react";
import MenuData from "../../data/MegaMenu";

const Nav = () => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const router = useRouter();

  const isActive = (href) => router.pathname === href;

  const toggleMenuItem = (item) => {
    setActiveMenuItem(activeMenuItem === item ? null : item);
  };

  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        <li className="has-dropdown">
          <Link
            className={`${activeMenuItem === "school" ? "open" : ""}`}
            href="#"
            onClick={() => toggleMenuItem("school")}
          >
            Nuestra Institución
            <i className="feather-chevron-down"></i>
          </Link>
          <ul
            className={`submenu ${
              activeMenuItem === "school" ? "active d-block" : ""
            }`}
          >
            {MenuData &&
              MenuData.ourInstitutionData.menuItems?.map((value, innerIndex) => (
                <li key={innerIndex}>
                  <Link href={value.link}>{value.title}</Link>
                </li>
              ))
            }
          </ul>
        </li>
        <li className="has-dropdown">
          <Link
            className={`${activeMenuItem === "tools" ? "open" : ""}`}
            href="#"
            onClick={() => toggleMenuItem("tools")}
          >
            Herramientas
            <i className="feather-chevron-down"></i>
          </Link>
          <ul
            className={`submenu ${
              activeMenuItem === "tools" ? "active d-block" : ""
            }`}
          >
            {MenuData &&
              MenuData.toolsData.menuItems?.map((value, innerIndex) => (
                <li key={innerIndex}>
                  <Link href={value.link} target={value.target}>{value.title}</Link>
                </li>
              ))
            }
          </ul>
        </li>
        <li >
          <Link
            href="/#gallery"
          >
            Galería
          </Link>
        </li>
        <li className="">
          <Link
            href="/calendar"
          >
            Calendario
          </Link>
        </li>
        <li className="">
          <Link
            href="/worldschooling"
          >
            Worldschooling
          </Link>
        </li>
        <li className="">
          <Link
            href="/contact"
          >
            Contáctanos
          </Link>
        </li>
        
      </ul>
    </nav>
  );
};
export default Nav;
